import { KebabActKC2 } from 'components/KebabActKC2';
import type {
    ContractStatusEnum,
    ActKc2StatusEnum,
    WorkOrderStatusEnum,
    ActKc2Data,
    ChapterEnum,
    CostGroupEnum,
} from 'gql/graphql';
import { ActKc2Title } from 'pages/Project/Common/ActKc2Title/ActKc2Title';
import type { BadgePropSize } from 'uikit';
import { Layout } from 'uikit';

interface ITitleActKC2ColumnsProps {
    id: number;
    status: ActKc2StatusEnum;
    workOrderStatus?: WorkOrderStatusEnum;
    contractStatus?: ContractStatusEnum;
    costGroup?: CostGroupEnum;
    number?: number;
    date?: Date;
    badgeSize?: BadgePropSize;
    isDisabledByProjectStatus?: boolean;
    onRefresh?: () => void;
    chapter?: ChapterEnum;
    workOrderSubObjectId?: number;
    seasonId?: number;
    isInactive?: boolean | null;
    isCorrection?: boolean | null;
    fullNumber?: string | null;
    correctionDate?: Date;
    canCreateCorrection?: boolean | null;
    isSKzS?: boolean | null;
    withHighLightManager?: (action?: () => void) => void;
    skzsPanelRefresh?: () => void;
}

interface ITitleActKC2ColumnsPropsWithChapter extends ITitleActKC2ColumnsProps {
    chapter: ChapterEnum;
    workOrderSubObjectId: number;
}

export const TitleActKC2Columns = (props: ITitleActKC2ColumnsPropsWithChapter | ITitleActKC2ColumnsProps) => {
    const {
        id,
        number,
        date,
        status,
        badgeSize = 'm',
        contractStatus,
        workOrderStatus,
        isDisabledByProjectStatus,
        workOrderSubObjectId,
        chapter,
        seasonId,
        onRefresh,
        isInactive,
        isCorrection,
        fullNumber,
        correctionDate,
        canCreateCorrection,
        withHighLightManager,
        isSKzS,
        skzsPanelRefresh,
        costGroup,
    } = props as ITitleActKC2ColumnsPropsWithChapter;

    return (
        <Layout style={{ width: '100%', alignItems: 'center' }}>
            <Layout style={{ width: '100%', overflowX: 'hidden' }}>
                <ActKc2Title
                    act={
                        {
                            date: isCorrection ? correctionDate : date,
                            status,
                            number: isCorrection ? fullNumber : number,
                        } as ActKc2Data
                    }
                    titleStyle={{ lineHeight: '24px' }}
                    size={badgeSize}
                    includeTitle
                />
            </Layout>

            <KebabActKC2
                id={id}
                isSKzSAct={isSKzS}
                number={isCorrection ? fullNumber : number}
                status={status}
                date={isCorrection ? correctionDate : date}
                onRefresh={onRefresh}
                statusContract={contractStatus}
                isDisabledByProjectStatus={isDisabledByProjectStatus}
                statusWorkOrder={workOrderStatus}
                chapter={chapter}
                workOrderSubObjectId={workOrderSubObjectId}
                seasonId={seasonId}
                isInactive={isInactive}
                isCorrection={isCorrection}
                canCreateCorrection={canCreateCorrection}
                withHighLightManager={withHighLightManager}
                skzsPanelRefresh={skzsPanelRefresh}
                costGroup={costGroup}
            />
        </Layout>
    );
};
TitleActKC2Columns.displayName = 'TitleActKC2Columns';
